module.exports = __webpack_public_path__ + "img/img_2.f9f22a71.jpg";